export default __webpack_public_path__ + "static/ReadyfortheNewNormal-f5b1bd3589114f592174ffa582b3ef85.jpg";